import React from 'react';

export default React.createContext({
    updateAnswer: (text, question, token) => {},
    getAnswer: (question) => {}
});